import { Component, AfterViewInit, ElementRef, Directive, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { SearchModel, PaginationModel, OrderModel, FilterModel, ExportModel } from 'src/common/models/search';
import { TranslationManager } from 'src/common/translation';
import { SearchCache } from '../search-cache/search-cache.component';

class AppTableEntity {
  entity: string;
  action: string;
  title: string;
}

@Directive({
  selector: '[search-title-new]'
})
export class ElementSearchTitleDirective {

  constructor(private el: ElementRef) {
  }

  translationManager = TranslationManager;

  @Input('search-title-new') set searchTitle(val: string) {
    this.el.nativeElement.searchTitle = val;

    if (this.el.nativeElement.onSearchTitleChange) {
      this.el.nativeElement.onSearchTitleChange(this.el.nativeElement);
    }
  }
}

@Component({
  selector: '[app-table]',
  templateUrl: './app-table.component.html'
})
export class AppTableComponent implements AfterViewInit {

  constructor(private elt: ElementRef) {
  }

  model: SearchModel;
  exportModel: ExportModel;
  onSearch: any;
  onExport: any;

  searchEntities: AppTableEntity[] = [];

  private totalCount: number = 0;

  ngAfterViewInit(): void {
    this.initModel();
    this.mapOrderElements();
    this.mapFilterElements();
    this.mapExportElements();
    this.mapPaginationElement();
    this.initModelFromStore();
    this.setTagsFromModel();
    this.setFiltersFromModel();
    this.bindOnSeachEntityTitleChangeEvents();

    this.setTotalCount(this.totalCount);
    this.setPageSize(this.model.pagination.size);
    this.setPage(this.model.pagination.page);
  }

  private bindOnSeachEntityTitleChangeEvents() {
    let element: HTMLElement = this.elt.nativeElement as HTMLElement;

    var elements = element.querySelectorAll('[search-entity]');
    if (elements != undefined) {
      elements.forEach((element: any) => {
        element.onSearchTitleChange = this.onSearchElementTitleChange.bind(this);
      })
    }
  }

  onSearchElementTitleChange(element: any) {
    let entity = this.searchEntities.find(s => s.entity == element.attributes['search-entity'].value);
    if (entity) {
      entity.title = element.searchTitle ? element.searchTitle : element.attributes['search-title'].value;
    }

    this.setTagsFromModel();
  }

  private mapPaginationElement() {
    let element: HTMLElement = this.elt.nativeElement as HTMLElement;
    var paginationElement = element.querySelector('[pagination-pages]') as any;
    if (paginationElement != undefined) {
      paginationElement.searchableTable = this;
      paginationElement.onchange = function (event: any) {
        this.searchableTable.setPage(parseInt(event.target.value));
        this.searchableTable.search();
      }
    }

    var paginationFirstPageElement = element.querySelector('[pagination-first-page]') as any;
    if (paginationFirstPageElement != undefined) {
      paginationFirstPageElement.searchableTable = this;
      paginationFirstPageElement.onclick = function (event: any) {
        this.searchableTable.setPage(1);
        this.searchableTable.search();
      }
    }

    var paginationPreviousPageElement = element.querySelector('[pagination-previous-page]') as any;
    if (paginationPreviousPageElement != undefined) {
      paginationPreviousPageElement.searchableTable = this;
      paginationPreviousPageElement.onclick = function (event: any) {
        this.searchableTable.setPage(this.searchableTable.model.pagination.page - 1);
        this.searchableTable.search();
      }
    }

    var paginationNextPageElement = element.querySelector('[pagination-next-page]') as any;
    if (paginationNextPageElement != undefined) {
      paginationNextPageElement.searchableTable = this;
      paginationNextPageElement.onclick = function (event: any) {
        this.searchableTable.setPage(this.searchableTable.model.pagination.page + 1);
        this.searchableTable.search();
      }
    }

    var paginationLastPageElement = element.querySelector('[pagination-last-page]') as any;
    if (paginationLastPageElement != undefined) {
      paginationLastPageElement.searchableTable = this;
      paginationLastPageElement.onclick = function (event: any) {
        this.searchableTable.setPage(Math.ceil(this.searchableTable.totalCount / this.searchableTable.model.pagination.size));
        this.searchableTable.search();
      }
    }

    var paginationSizesElement = element.querySelector('[pagination-sizes]') as any;
    if (paginationSizesElement != undefined) {
      paginationSizesElement.searchableTable = this;
      paginationSizesElement.onchange = function (event: any) {
        this.searchableTable.setPageSize(parseInt(event.target.value));
        this.searchableTable.calculatePages();
        this.searchableTable.setPage(1);
        this.searchableTable.search();
      }
    }
  }

  resetOrderElements() {
    let element: HTMLElement = this.elt.nativeElement as HTMLElement;

    var orderElements = element.querySelectorAll('[order]');
    if (orderElements != undefined) {
      orderElements.forEach((element: any) => {
        element.orderDirection = undefined;
      })
    }
  }

  private setVisibilityToPaginationArrows() {
    let element: HTMLElement = this.elt.nativeElement as HTMLElement;

    var paginationFirstPageElement = element.querySelector('[pagination-first-page]') as any;
    var paginationPreviousPageElement = element.querySelector('[pagination-previous-page]') as any;
    var paginationNextPageElement = element.querySelector('[pagination-next-page]') as any;
    var paginationLastPageElement = element.querySelector('[pagination-last-page]') as any;

    if (paginationFirstPageElement != undefined) {
      this.setVisibilityToElement(paginationFirstPageElement, this.model.pagination.page != 1);
    }

    if (paginationPreviousPageElement != undefined) {
      this.setVisibilityToElement(paginationPreviousPageElement, this.model.pagination.page != 1);
    }

    if (paginationNextPageElement != undefined) {
      this.setVisibilityToElement(paginationNextPageElement, this.model.pagination.page != Math.ceil(this.totalCount / this.model.pagination.size));
    }

    if (paginationLastPageElement != undefined) {
      this.setVisibilityToElement(paginationLastPageElement, this.model.pagination.page != Math.ceil(this.totalCount / this.model.pagination.size));
    }
  }

  private setVisibilityToElement(element: any, show: boolean) {
    element.setAttribute('style', !show ? 'display: none' : '');
  }

  private initModel() {

    this.model = new SearchModel();
    this.model.filters = [];

    this.model.pagination = new PaginationModel();
    this.model.pagination.page = 1;
    this.model.pagination.size = 10;

    this.exportModel = new ExportModel();
    this.exportModel.filters = [];
    this.exportModel.columns = [];
  }

  initModelFromStore() {

    let storedSearch = SearchCache.get(`template-search-${SearchCache.hash(this.searchEntities)}`);

    if (storedSearch) {
      this.model = storedSearch;
    }

    if (SearchCache.Filters) {
      this.model.filters = SearchCache.Filters;
      SearchCache.Filters = undefined;
    }
  }

  private mapOrderElements() {

    let element: HTMLElement = this.elt.nativeElement as HTMLElement;

    var orderElements = element.querySelectorAll('[order]');
    if (orderElements != undefined) {
      orderElements.forEach((element: any) => {
        element.searchableTable = this;

        element.onclick = function (event: any) {

          let htmlElement = event.currentTarget;
          let entity = htmlElement.attributes['order-entity']

          if (entity) {

            let orderDirection = this.orderDirection;
            this.searchableTable.resetOrderElements();
            this.orderDirection = orderDirection;

            let direction = !this.orderDirection || this.orderDirection === 'DESC' ? 'ASC' : 'DESC';
            this.orderDirection = direction;

            if (!this.searchableTable.model.order) {
              this.searchableTable.model.order = new OrderModel();
            }

            this.searchableTable.model.order.entity = entity.value;
            this.searchableTable.model.order.direction = direction;

            this.searchableTable.setTagsFromModel();
            this.searchableTable.setPage(1);
            this.searchableTable.search();
          }
        }
      })
    }
  }

  setFiltersFromModel() {
    this.setMapFromModel(this.model);
  }

  setHeadersFromModel() {
    this.exportModel.columns = [];
    let element: HTMLElement = this.elt.nativeElement as HTMLElement;
    var inputElements = element.querySelectorAll('[order]');
    if (inputElements != undefined) {
      inputElements.forEach((element: any) => {
        let title = element.innerHTML.trim();
        let entity = element.attributes['order-entity'].value;
        this.exportModel.columns.push({ "entity": entity, "title": title });
      })
    }
  }

  setMapFromModel(model: any) {
    let element: HTMLElement = this.elt.nativeElement as HTMLElement;

    var inputElements = element.querySelectorAll('[search-input]');
    if (inputElements != undefined) {
      inputElements.forEach((element: any) => {
        let entity = element.attributes['search-entity'];
        let action = element.attributes['search-action'];

        let filter = model.filters.find(s => s.entity === entity.value && s.action === action.value);

        element.value = null;

        if (filter) {
          element.value = filter.value;
        }
      })
    }

    var selectElements = element.querySelectorAll('[search-select]');
    if (selectElements != undefined) {
      selectElements.forEach((element: any) => {
        let entity = element.attributes['search-entity'];
        let action = element.attributes['search-action'];

        let filter = this.model.filters.find(s => s.entity === entity.value && s.action === action.value);

        element.value = null;

        if (filter) {
          element.value = filter.value;
        }
      })
    }

    inputElements = element.querySelectorAll('[search-date]');
    if (inputElements != undefined) {
      inputElements.forEach((element: any) => {
        let entity = element.attributes['search-entity'];
        let action = element.attributes['search-action'];

        let dateElement = element.querySelectorAll('input')[0];

        dateElement.value = null;

        let filter = model.filters.find(s => s.entity === entity.value && s.action === action.value);

        if (filter) {
          dateElement.value = filter.value;
        }
      })
    }

    inputElements = element.querySelectorAll('[search-multiselect]');
    if (inputElements != undefined) {
      inputElements.forEach((element: any) => {
        let entity = element.attributes['search-entity'];
        let action = element.attributes['search-action'];

        let filters = model.filters.filter(s => s.entity === entity.value && s.action === action.value) as FilterModel[];

        let checkboxElements = element.querySelectorAll(`input[option-value]`) as any[];
        if (checkboxElements && checkboxElements.length > 0) {
          checkboxElements.forEach(c => {
            c.checked = false;
          });
        }

        if (filters) {
          filters.forEach(f => {
            let checkboxElements = element.querySelectorAll(`input[option-value='${f.value}']`);
            if (checkboxElements && checkboxElements.length > 0) {
              checkboxElements[0].checked = true;
            }
          })
        }
      })
    }
  }

  resetFiltersInModel() {
    this.model.filters.splice(0, this.model.filters.length);
  }

  setExportsToModel() {
    this.exportModel.order = this.model.order;
    this.mapToModel(this.exportModel);
  }

  setFiltersToModel() {
    this.mapToModel(this.model);
  }

  mapToModel(model: any) {
    let element: HTMLElement = this.elt.nativeElement as HTMLElement;

    model.filters.splice(0, model.filters.length);

    var inputElements = element.querySelectorAll('[search-input]');
    if (inputElements != undefined) {
      inputElements.forEach((element: any) => {
        if (element.value != undefined && element.value.trim() != '') {
          let entity = element.attributes['search-entity'];
          let action = element.attributes['search-action'];

          let filter = model.filters.find(s => s.entity === entity.value && s.action === action.value);

          if (filter) {
            filter.value = element.value;
          } else {
            model.filters.push({ entity: entity.value, value: element.value, action: action.value });
          }
        }
      })
    }

    inputElements = element.querySelectorAll('[search-multiselect]');
    if (inputElements != undefined) {
      inputElements.forEach((element: any) => {
        let entity = element.attributes['search-entity'];
        let action = element.attributes['search-action'];

        let checkboxElements = element.querySelectorAll(`input[option-value]`) as any[];

        if (checkboxElements && checkboxElements.length > 0) {
          checkboxElements.forEach(elem => {
            let checkboxValue = elem.attributes['option-value'];

            let filter = model.filters.find(s => s.entity === entity.value && s.action === action.value && s.value === checkboxValue.value);

            if (filter) {
              model.filters.splice(model.filters.indexOf(filter), 1);
            }

            if (elem.checked) {
              model.filters.push({ entity: entity.value, value: checkboxValue.value, action: action.value });
            }
          })
        }
      })
    }

    inputElements = element.querySelectorAll('[search-select]');
    if (inputElements != undefined) {
      inputElements.forEach((element: any) => {
        if (element.value != undefined && element.value.trim() != '') {
          let entity = element.attributes['search-entity'];
          let action = element.attributes['search-action'];

          let filter = this.model.filters.find(s => s.entity === entity.value && s.action === action.value);

          if (filter) {
            filter.value = element.value;
          } else {
            this.model.filters.push({ entity: entity.value, value: element.value, action: action.value });
          }
        }
      })
    }

    inputElements = element.querySelectorAll('[search-date]');
    if (inputElements != undefined) {
      inputElements.forEach((element: any) => {
        let entity = element.attributes['search-entity'];
        let action = element.attributes['search-action'];

        let value = element.querySelectorAll('input')[0].value;

        let filter = model.filters.find(s => s.entity === entity.value && s.action === action.value);

        if (filter) {
          filter.value = value;
        } else {
          model.filters.push({ entity: entity.value, value: value, action: action.value });
        }
      })
    }
  }

  private addElementToEntities(element: any) {
    let entity = element.attributes['search-entity'];
    let action = element.attributes['search-action'];

    this.searchEntities.push({
      entity: entity != undefined ? entity.value : undefined,
      action: action != undefined ? action.value : undefined,
      title: element.searchTitle ? element.searchTitle : element.attributes['search-title'].value
    })
  }

  private mapExportElements() {
    let element: HTMLElement = this.elt.nativeElement as HTMLElement;
    var doSearchElement = element.querySelector('[do-export]') as any;
    if (doSearchElement != undefined) {
      doSearchElement.searchableTable = this;
      this.exportModel.action = doSearchElement.attributes['action-name'].value;
      doSearchElement.onclick = function (event: any) {
        this.searchableTable.setExportsToModel();
        this.searchableTable.setHeadersFromModel();
        this.searchableTable.export();
      }
    }
  }

  private mapFilterElements() {

    let element: HTMLElement = this.elt.nativeElement as HTMLElement;

    var inputElements = element.querySelectorAll('[search-input]');
    if (inputElements != undefined) {
      inputElements.forEach((element: any) => {
        this.addElementToEntities(element);
        element.searchableTable = this;
        element.onkeydown = function (event: any) {
          if (event.keyCode === 13) {
            this.searchableTable.setFiltersToModel();
            this.searchableTable.setTagsFromModel();
            this.searchableTable.setPage(1);
            this.searchableTable.search();
          }
          ;

          return true;
        }
      })
    }

    inputElements = element.querySelectorAll('[search-multiselect]');
    if (inputElements != undefined) {
      inputElements.forEach((element: any) => {
        this.addElementToEntities(element);
      })
    }

    inputElements = element.querySelectorAll('[search-select]');
    if (inputElements != undefined) {
      inputElements.forEach((element: any) => {
        this.addElementToEntities(element);
        element.searchableTable = this;
        element.onchange = function (event: any) {

          this.searchableTable.setFiltersToModel();
          this.searchableTable.setTagsFromModel();
          this.searchableTable.setPage(1);
          this.searchableTable.search();

          return true;
        }
      })
    }

    var filterButtonElement = element.querySelector('[filter-open]') as any;
    if (filterButtonElement != undefined) {
      filterButtonElement.searchableTable = this;
      filterButtonElement.onclick = function (event: any) {
        if (this.parentElement.parentElement.className.indexOf('filter-open') == -1) {
          this.parentElement.parentElement.classList.add('filter-open');
          this.searchableTable.setFiltersFromModel();
        }
      }
    }

    var filterCloseButtonElement = element.querySelector('[filter-close]') as any;
    if (filterCloseButtonElement != undefined) {
      filterCloseButtonElement.onclick = function (event: any) {
        if (this.parentElement.parentElement.parentElement.parentElement.className.indexOf('filter-open') > -1) {
          this.parentElement.parentElement.parentElement.parentElement.className = this.parentElement.parentElement.parentElement.parentElement.className.replace('filter-open', '');
        }
      }
    }

    var doSearchElement = element.querySelector('[do-search]') as any;
    if (doSearchElement != undefined) {
      doSearchElement.searchableTable = this;
      doSearchElement.onclick = function (event: any) {
        this.searchableTable.setFiltersToModel();
        this.searchableTable.setTagsFromModel();
        this.searchableTable.setPage(1);
        this.searchableTable.search();
      }
    }

    var resetSearchElement = element.querySelector('[reset-search]') as any;
    if (resetSearchElement != undefined) {
      resetSearchElement.searchableTable = this;
      resetSearchElement.onclick = function (event: any) {
        this.searchableTable.resetFiltersInModel();
        this.searchableTable.setFiltersFromModel();
        this.searchableTable.setTagsFromModel();
        this.searchableTable.setPage(1);
        this.searchableTable.search();
      }
    }

    var resetSearchElementManually = element.querySelector('[reset-search-manually]') as any;
    if (resetSearchElementManually != undefined) {
      resetSearchElementManually.searchableTable = this;
      resetSearchElementManually.onclick = function (event: any) {
        this.searchableTable.resetFiltersInModel();
        this.searchableTable.setFiltersFromModel();
        this.searchableTable.setTagsFromModel();
        this.searchableTable.setPage(1);
        this.searchableTable.search();
      }
    }
  }

  setTagsFromModel() {
    let element: HTMLElement = this.elt.nativeElement as HTMLElement;

    var tags = element.querySelector('[search-tags]') as HTMLElement;
    if (tags != undefined) {

      // Set No Content invisible
      let tagsNoContent = tags.querySelector('[search-tag-no-content]') as HTMLElement;
      if (tagsNoContent != undefined) {
        tagsNoContent.setAttribute('style', 'display: none');
      }

      let tagsSpecialContent = tags.querySelector('[search-tag-special-content]') as HTMLElement;
      if (tagsSpecialContent != undefined) {
        tagsSpecialContent.setAttribute('style', 'display: none');
        if(this.model != undefined && this.model.filters != undefined && this.model.filters.length > 0){
          tagsSpecialContent.setAttribute('style', 'display: block');
        }
      }

      // Remove all tags
      let tagItems = tags.querySelectorAll('[search-tag-item]');
      if (tagItems != undefined) {
        tagItems.forEach((tagItem: any) => {
          tags.removeChild(tagItem);
        })
      }

      tagItems = tags.querySelectorAll('[order-tag-item]');
      if (tagItems != undefined) {
        tagItems.forEach((tagItem: any) => {
          tags.removeChild(tagItem);
        })
      }

      if (this.model != undefined && this.model.filters != undefined) {
        this.model.filters.forEach((filter: FilterModel) => {
          tags.childNodes.forEach((node: any) => {
            if (node.hasAttribute('search-tag-prototype')) {

              let newNode = node.cloneNode(true) as HTMLElement;

              newNode.removeAttribute('style');
              newNode.removeAttribute('search-tag-prototype');
              newNode.setAttribute('search-tag-item', '');

              var tagTitle = newNode.querySelector('[search-tag-prototype-title]') as HTMLElement;
              if (tagTitle != undefined) {
                let searchEntity = this.searchEntities.find(s => s.entity === filter.entity && s.action === filter.action);
                tagTitle.textContent = searchEntity != undefined && searchEntity.title != undefined ? `${searchEntity.title}:` : '';
              }

              var tagValue = newNode.querySelector('[search-tag-prototype-value]') as HTMLElement;
              if (tagValue != undefined) {
                tagValue.textContent = filter.value;
              }

              var tagClose = newNode.querySelector('[search-tag-prototype-close]') as any;
              if (tagClose != undefined) {
                tagClose.searchableTable = this;
                tagClose.searchableFilter = filter;
                tagClose.onclick = function (event: any) {
                  this.searchableTable.removeFilter(this.searchableFilter);
                  this.searchableTable.setFiltersFromModel();
                  this.searchableTable.setTagsFromModel();
                  this.searchableTable.setPage(1);
                  this.searchableTable.search();
                }
              }

              tags.appendChild(newNode);
            }
          })
        })
      }

      if (this.model != undefined && this.model.order != undefined) {
        tags.childNodes.forEach((node: any) => {
          if (node.hasAttribute('order-tag-prototype')) {

            let newNode = node.cloneNode(true) as HTMLElement;

            newNode.removeAttribute('style');
            newNode.removeAttribute('order-tag-prototype');
            newNode.setAttribute('order-tag-item', '');

            var tagTitle = newNode.querySelector('[order-tag-prototype-title]') as HTMLElement;
            if (tagTitle != undefined) {
              let searchEntity = this.searchEntities.find(s => s.entity === this.model.order.entity);
              tagTitle.textContent = searchEntity != undefined || searchEntity.title != undefined ? `${searchEntity.title}:` : '';
            }

            var tagValue = newNode.querySelector('[order-tag-prototype-value]') as HTMLElement;
            if (tagValue != undefined) {
              if (this.model.order.direction == 'ASC') {
                tagValue.textContent = TranslationManager.getTranslation('Растући');
              } else {
                tagValue.textContent = TranslationManager.getTranslation('Опадајући');
              }
            }

            var tagClose = newNode.querySelector('[order-tag-prototype-close]') as any;
            if (tagClose != undefined) {
              tagClose.searchableTable = this;
              tagClose.onclick = function (event: any) {
                this.searchableTable.removeOrder();
                this.searchableTable.setFiltersFromModel();
                this.searchableTable.setTagsFromModel();
                this.searchableTable.setPage(1);
                this.searchableTable.search();
              }
            }

            tags.appendChild(newNode);
          }
        })
      }

      if (tagsNoContent != undefined && (this.model == undefined || ((this.model.filters == undefined || this.model.filters.length == 0) && this.model.order == undefined))) {
        tagsNoContent.setAttribute('style', 'display: block');
      }
    }
  }

  removeFilter(filter: FilterModel) {
    if (this.model != undefined && this.model.filters != undefined) {
      this.model.filters.splice(this.model.filters.indexOf(filter), 1);
    }
  }

  removeOrder() {
    if (this.model != undefined && this.model.order != undefined) {
      this.model.order = undefined;
    }
  }

  doSearch() {
    this.setFiltersToModel();
    this.setPage(1);
    this.search();
  }

  doExport() {
    this.setExportsToModel();
    this.export();
  }

  search() {
    this.saveSearch();
    if (this.onSearch) {
      this.onSearch(this.model);
    }
  }

  saveSearch() {
    SearchCache.store(`template-search-${SearchCache.hash(this.searchEntities)}`, this.model);
  }

  export() {
    if (this.onExport) {
      this.onExport(this.exportModel);
    }
  }

  setTotalCount(count: number) {
    this.totalCount = count;

    let element: HTMLElement = this.elt.nativeElement as HTMLElement;
    var countElement = element.querySelector('[pagination-total-count]');
    if (countElement != undefined) {
      countElement.textContent = this.totalCount.toString();
    }

    this.calculatePages();
  }

  setPageSize(size: number) {
    this.model.pagination.size = size;

    let element: HTMLElement = this.elt.nativeElement as HTMLElement;
    var countElement = element.querySelector('[pagination-sizes]') as any;
    if (countElement != undefined) {
      countElement.value = this.model.pagination.size.toString();
    }
  }

  private showPaginationContainer(show: boolean) {
    let element: HTMLElement = this.elt.nativeElement as HTMLElement;
    var paginationElement = element.querySelector('[pagination]');
    if (paginationElement != undefined) {
      paginationElement.setAttribute('style', !show ? 'display: none' : '');
    }
  }

  private calculatePages() {
    this.showPaginationContainer(this.totalCount > 0);

    if (this.totalCount > 0) {
      let numberOfPages = Math.ceil(this.totalCount / this.model.pagination.size);

      let element: HTMLElement = this.elt.nativeElement as HTMLElement;
      let paginationPagesCount = element.querySelector('[pagination-pages-count]');
      if (paginationPagesCount != undefined) {
        paginationPagesCount.textContent = numberOfPages.toString();
      }

      let paginationPages = element.querySelector('[pagination-pages]');
      if (paginationPages != undefined) {
        while (paginationPages.firstChild) {
          paginationPages.removeChild(paginationPages.lastChild);
        }
      }

      for (let i = 1; i <= numberOfPages; i++) {
        paginationPages.innerHTML += `<option value='${i}'>${i}</option>`;
      }

      this.setPage(this.model.pagination.page);
    }
  }

  setPage(page: number) {
    this.model.pagination.page = page;

    if (this.totalCount > 0) {
      let numberOfPages = Math.ceil(this.totalCount / this.model.pagination.size);

      let element: HTMLElement = this.elt.nativeElement as HTMLElement;
      let paginationPages = element.querySelector('[pagination-pages]') as any;
      if (paginationPages != undefined) {
        while (paginationPages.firstChild) {
          paginationPages.removeChild(paginationPages.lastChild);
        }
      }

      for (let i = 1; i <= numberOfPages; i++) {
        paginationPages.innerHTML += `<option value='${i}'>${i}</option>`;
      }

      paginationPages.value = this.model.pagination.page;
    }

    this.setVisibilityToPaginationArrows();
  }
}
